var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4381 2.32465C23.786 2.12095 24.2146 2.12095 24.5626 2.32465L34.7997 8.31817C35.1476 8.52187 35.362 8.89832 35.362 9.30572V21.2928C35.362 21.7001 35.1476 22.0766 34.7997 22.2803L24.5626 28.2738C24.2146 28.4775 23.786 28.4775 23.4381 28.2738L13.2009 22.2803C12.853 22.0766 12.6387 21.7001 12.6387 21.2928V9.30572C12.6387 8.89832 12.853 8.52187 13.2009 8.31817L23.4381 2.32465Z",
    stroke: "#48E1A7",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6483 26.9492L27.541 40.9616L20.4584 40.9616L21.3511 26.9492",
    stroke: "#48E1A7",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4007 41.8405C17.4616 41.3385 17.8877 40.9609 18.3934 40.9609H29.606C30.1118 40.9609 30.5379 41.3385 30.5988 41.8406L31.0823 45.8284H16.917L17.4007 41.8405Z",
    stroke: "#48E1A7",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.f6362f0feade338e9f434ddbf08fd1f9.svg";
export { ForwardRef as ReactComponent };